/**
 *
 * @constructor
 */
function ChannelPage() {
    /**
     *
     */
    ChannelPage.prototype.initialize = function (console, mesh, channel) {
        this.id = "channel";
        this.console = console;
        this.mesh = mesh;
        this.channel = channel;

        return this;
    };

    /**
     *
     */
    ChannelPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService.getChannel(this.mesh, this.channel).done(function (channel) {
            this.channel = channel;

            this.console.safeApply();
        }.bind(this)).fail();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    ChannelPage.prototype.onPost = function (post) {
        if (post.channel != this.channel._id)
        {
            return;
        }

        this.channel.posts.push(post);
        this.channel.posts = this.channel.posts.slice(); // TODO Ugly but watchCollection did not work

        this.console.safeApply();
    };

    /**
     *
     */
    ChannelPage.prototype.findChannel = function (id) {
        for (var n in this.channels) {
            if (this.channels[n]._id === id) {
                return this.channels[n];
            }
        }

        throw new Exception("Cannot find Channel with ID " + id);
    };

    /**
     *
     */
    ChannelPage.prototype.createPost = function (post) {
        this.console.consoleService.createPost(this.mesh, this.channel, this.postContent, 'message').done(function () {
            this.postContent = null;

            this.console.safeApply();
        }.bind(this));
    };

    /**
     *
     */
    ChannelPage.prototype.leave = function () {
    };

    /**
     *
     */
    ChannelPage.prototype.showDateRow = function (index) {
        if (index == 0) {
            return true;
        }

        return moment(this.channel.posts[index - 1].timestamp).dayOfYear() != moment(this.channel.posts[index].timestamp).dayOfYear();
    };

    /**
     *
     */
    ChannelPage.prototype.openPostObjectDialog = function () {
        this.console.Ui.turnOn("postObjectDialog");
    };

    /**
     *
     */
    ChannelPage.prototype.prettifyDate = function (timestamp) {
        var now = moment();
        var date = moment(timestamp);

        if (date.isSame(now, 'day')) {
            return "Today";
        } else {
            return moment(timestamp).format('dddd, MMMM Do YYYY');
        }
    };
}
